import { useEffect, useState } from 'react';

const REFRESH_TIME_MILLISECONDS = 5 * 1000;

/**
 * Hook que devuelve el indice del texto a mostrar.
 * Este indice lo aumenta según el intervalo de tiempo
 * especificado.
 * @param length: cantidad total de textos a mostrar.
 */
export function useTextLoadingAnimation(length: number | undefined) {
  const [index, setIndex] = useState<number>(0);
  const lastIndex = length !== undefined ? length - 1 : undefined;

  const update = () => {
    let interval: NodeJS.Timeout | undefined;

    if (lastIndex !== undefined) {
      interval = setInterval(() => {
        if (index < lastIndex) {
          setIndex((current) => (current < lastIndex ? current + 1 : current));
        } else {
          clearInterval(interval);
        }
      }, REFRESH_TIME_MILLISECONDS);
    }

    return () => interval && clearInterval(interval);
  };

  useEffect(update, [index, lastIndex]);

  return index;
}
